(() => {
  const BUTTON_SELECTOR = '.button, .button-secondary, button.shopify-payment-button__button--unbranded';
  const TEXT_BUTTON_CLASS = 'khayali-text-button';
  const IGNORE_TEXT_WITHIN = '.visually-hidden, .sr-only, [aria-hidden="true"], script, style, template, svg';

  /**
   * @param {HTMLElement} button
   */
  function hasVisibleText(button) {
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT, {
      acceptNode(textNode) {
        if (!textNode.nodeValue || !textNode.nodeValue.trim()) {
          return NodeFilter.FILTER_REJECT;
        }

        const parent = textNode.parentElement;
        if (!parent) {
          return NodeFilter.FILTER_REJECT;
        }

        if (parent.closest(IGNORE_TEXT_WITHIN)) {
          return NodeFilter.FILTER_REJECT;
        }

        const style = window.getComputedStyle(parent);
        if (style.display === 'none' || style.visibility === 'hidden') {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      },
    });

    return walker.nextNode() !== null;
  }

  /**
   * @param {HTMLElement} button
   */
  function hasIcon(button) {
    return button.querySelector('svg') !== null;
  }

  /**
   * Allow icon+text only for the main product add-to-cart CTA, not quick-add card buttons.
   * @param {HTMLElement} button
   */
  function shouldAllowIconButton(button) {
    if (!button.classList.contains('add-to-cart-button')) return false;
    if (button.classList.contains('quick-add__button')) return false;
    if (button.closest('quick-add-component')) return false;

    return true;
  }

  /**
   * @param {HTMLElement} button
   */
  function classifyButton(button) {
    const allowIconButton = hasIcon(button) && shouldAllowIconButton(button);

    if (hasVisibleText(button) && (!hasIcon(button) || allowIconButton)) {
      button.classList.add(TEXT_BUTTON_CLASS);
    } else {
      button.classList.remove(TEXT_BUTTON_CLASS);
    }
  }

  function classifyAllButtons(root = document) {
    /** @type {NodeListOf<HTMLElement>} */
    const buttons = root.querySelectorAll(BUTTON_SELECTOR);
    buttons.forEach(classifyButton);
  }

  let scheduled = false;
  function scheduleClassify() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      classifyAllButtons();
      scheduled = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => classifyAllButtons(), { once: true });
  } else {
    classifyAllButtons();
  }

  const observer = new MutationObserver(() => {
    scheduleClassify();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'],
  });
})();
